import React, {useContext, useEffect, useState} from 'react';
import {PlayerContext} from "../../../../shared/contexts/playerContext";
import DataEditor from "../../../../shared/components/dataEditor/DataEditor";
import dayjs from "dayjs";

const CorruptData = () => {
    const {playerData} = useContext(PlayerContext);
    const [playInfo, setPlayInfo] = useState(JSON.parse(playerData.corruptData[0]?.errorData || '{}'));
    const [lastUpdated, setLastUpdated] = useState(null);

    useEffect(() => {
        setPlayInfo(JSON.parse(playerData.corruptData[0]?.errorData || '{}'));
        setLastUpdated(playerData.corruptData[0]?.updated || '없음');
    }, [playerData.corruptData]);

    if (Object.keys(playInfo).length === 0) {
        return <div>손상된 데이터가 없습니다.</div>;
    }

    return (
        <div style={{ padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
            <div>
                마지막 저장 시간: {lastUpdated}
            </div>
            <DataEditor initialData={playInfo} />
        </div>
    );
};

export default CorruptData;